import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import criminalBg from "../../images/law-areas/criminal-bg.png"
import criminal from "../../images/law-areas/criminal.png"
import { device } from "../../styles/media"

const AreaContainer = styled.div<{ isShown: boolean; background: string }>`
  width: 100%;
  max-width: 378px;
  height: ${props => (props.isShown ? "205px" : "0")};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: url(${props => props.background});
  background-size: cover;
  flex: 1 0 30%;
  margin-right: 33px;
  margin-bottom: ${props => (props.isShown ? "64px" : "0")};
  box-shadow: 0px 8px 13px rgba(0, 0, 0, 0.25);
  transition: all 0.3s;
  @media ${device.tablet} {
    flex: 1 0 100%;
    width: 100%;
    max-width: none;
    margin: 0;
    box-shadow: none;
  }
`
AreaContainer.propTypes = {
  background: PropTypes.any,
  isShown: PropTypes.bool,
}

const AreaTitle = styled.h4`
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 29px;
  margin-top: 13px;
  color: #fff;
`

const AreaIcon = styled.div<{ icon: string }>`
  width: 60px;
  height: 60px;
  background-image: url(${props => props.icon});
  background-size: contain;
  background-repeat: no-repeat;
`
AreaIcon.propTypes = {
  icon: PropTypes.any,
}

export const Area = ({ title, icon, background, isShown }) => (
  <AreaContainer background={background} isShown={isShown}>
    <AreaIcon icon={icon} />
    <AreaTitle>{title}</AreaTitle>
  </AreaContainer>
)

Area.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.any,
  background: PropTypes.any,
  isShown: PropTypes.bool,
}

Area.defaultProps = {
  title: "Уголовное право",
  icon: criminal,
  background: criminalBg,
  isShown: true,
}
